import PropTypes from "prop-types";
import { t } from "../../../../../services";
import { strCode } from "../../../../../consts";
import { FlexContainers, SmallButton, WrapperContainer } from "../../../../../components";

export const LocalizationsModalControlButtons = ({ onCancel, onSave, loading }) => {
  return (
    <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={8} width="100%">
      <SmallButton onClick={onCancel} disabled={loading} secondary>
        {t(strCode.CANCEL_BTN)}
      </SmallButton>

      <SmallButton onClick={onSave} disabled={loading} loading={loading}>
        {t(strCode.SAVE_BTN)}
      </SmallButton>
    </WrapperContainer>
  );
};

LocalizationsModalControlButtons.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};
